import React from 'react'
import { LoadingSpinnerWrapper, Spinner } from './LoadingSpinner.styles'

export const LoadingSpinner = () => (
  <LoadingSpinnerWrapper>
    <Spinner />
  </LoadingSpinnerWrapper>
)
export default LoadingSpinner
